module.exports = "<span class=\"skeleton\" [style.width]=\"width\" [style.height]=\"height\" [style.borderRadius]=\"borderRadius\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/skeleton/skeleton.component.html
// module id = ./src/app/components/tools/skeleton/skeleton.component.html
// module chunks = main